import React from "react";
import PropTypes from "prop-types";
import { Badge, withStyles, IconButton, Tooltip } from "@material-ui/core";
import { useIntl } from "react-intl";

import CallLogOutline from "../../../../_common/icones/CallLogOutline";
import { createSnackbar } from "../../../../_common";
import { ACCESS_LEVEL } from "../../../../_common/constantes";
import { useSelectPermission, useUsuario } from "../../../../hooks";
import ButtonLink from "../../../../_common/components/ButtonLink";
import permissions from "../../../../_common/permissions";

function LinkAnaliseLigacao({ classes, historicoLigacaoId, qtdNaoLidos, icone = false, usuarioIdLigacao }) {
  const intl = useIntl();
  const { id } = useUsuario();

  const abrirAudiosPermission = useSelectPermission(permissions.ABRIR_AUDIO_DAS_LIGACOES);
  if (!icone && abrirAudiosPermission && abrirAudiosPermission.nivelAcesso === ACCESS_LEVEL.NONE) return null;

  const abrirAnaliseLigacoes = () => {
    if (
      icone &&
      abrirAudiosPermission &&
      (abrirAudiosPermission.nivelAcesso === ACCESS_LEVEL.NONE ||
        (abrirAudiosPermission.nivelAcesso === ACCESS_LEVEL.INDIVIDUAL && usuarioIdLigacao !== id))
    ) {
      createSnackbar(intl.formatMessage({ defaultMessage: "Usuário sem permissão" }));
      return;
    }
    window.open(`/spotter/analise/ligacao/${historicoLigacaoId}`, "_blank");
  };

  return (
    <>
      {icone && (
        <IconButton onClick={abrirAnaliseLigacoes}>
          <Tooltip
            title={intl.formatMessage({
              defaultMessage: "Análise de ligação",
            })}
          >
            <CallLogOutline />
          </Tooltip>
        </IconButton>
      )}
      {!icone && (
        <ButtonLink variant="caption" onClick={abrirAnaliseLigacoes} style={{ paddingRight: 8 }}>
          {intl.formatMessage({ defaultMessage: "Análise de ligação" })}
          {qtdNaoLidos > 0 && (
            <Badge
              classes={{
                root: classes.badgeRoot,
                badge: classes.badge,
              }}
              badgeContent={qtdNaoLidos}
              color="primary"
            />
          )}
        </ButtonLink>
      )}
    </>
  );
}

LinkAnaliseLigacao.propTypes = {
  historicoLigacaoId: PropTypes.number,
  qtdNaoLidos: PropTypes.number,
  icone: PropTypes.bool,
  usuarioIdLigacao: PropTypes.number,
};

export default withStyles({
  badgeRoot: {
    display: "none",
    marginLeft: 8,
  },
  badge: {
    fontSize: 10,
    position: "initial",
    transform: "none",
  },
})(LinkAnaliseLigacao);
